<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody"
        :label="$t('Nuevo Contrato')"
        v-loading="loading"
        element-loading-text="Cargando..."
        element-loading-background="rgba(255, 255, 255)"
      >
        <br />
        <el-row :gutter="20">
          <el-col :md="12">
            <h2>{{$t('Flujos de Revisión.')}}</h2>
          </el-col>
          <el-col :md="12">
            <StepsContrato v-bind:step="1"></StepsContrato>
          </el-col>
        </el-row>

        <!-- Workflow -->
        <br />
        <br />
        <br>
        <el-row :gutter="20">
          <el-col :md="6">
            <div>
              <h3>{{$t('Flujo de revisión')}}</h3>
              <el-select
                @change="changeWorkflow"
                v-model="selectedWorkflows"
                filterable
                :placeholder="$t('Seleccione un flujo de revisión')"
                class="w-90"
              >
                <el-option
                  v-for="workflow in workflows"
                  :label="workflow.nombre"
                  :value="workflow._id"
                  :key="workflow._id"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :md="18">
            <center>
              <h3>{{workflowView ? workflowView.nombre : "" }}</h3>
            </center>
            <Workflow :workflow="workflowView"/>
          </el-col>
        </el-row>

        <br />
        <br />
        <br />
        <br />

        <el-col :span="24" class="centrar">
          <el-button-group>
            <el-button type="primary" @click="backStep()" icon="el-icon-arrow-left">Regresar</el-button>
            <el-button @click="nextStep()" type="primary">
              {{$t('Siguiente')}}
              <i class="el-icon-arrow-right el-icon-right"></i>
            </el-button>
          </el-button-group>
        </el-col>
        <br />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import StepsContrato from "@/components/contracts/StepsContrato.vue";
import Workflow from "@/components/workflows/Workflow2.vue";

export default {
  name: "wizard",
  components: {
    StepsContrato,
    Workflow
  },
  data() {
    return {
      workflowView: null,
      loading: false,
      selectedWorkflows: ""
    };
  },
  async created() {
    if (Object.keys(this.$store.getters.newContract).length === 0) {
      this.$router.push({ name: "contractCreateStep1" });
    }
    this.selectedWorkflows = this.newContract.workflow;
    if (this.selectedWorkflows !== "") {
      this.changeWorkflow(this.selectedWorkflows)
    }
    await this.getWorkflows();
  },
  computed: {
    ...mapGetters({
      workflows: "workflows",
      newContract: "newContract"
    })
  },
  methods: {
    ...mapActions(["getWorkflows", "setNewContract"]),
    getUser(id) {
      let user = this.$store.getters.usersFaena.find(x => x._id === id);
      if (user) {
        return `${user.nombre} ${user.apellido}`;
      } else {
        return "Usuario no encontrado";
      }
    },
    changeWorkflow(item) {
      let workflow = this.workflows.find(x => x._id === item);
      this.workflowView = workflow;
    },
    backStep() {
      this.$router.push({ name: "contractCreateStep1" });
    },
    async nextStep() {
      this.loading = true;
      if (this.selectedWorkflows !== "") {
        const auxContract = Object.assign({}, this.newContract, {
          workflow: this.selectedWorkflows
        });
        this.setNewContract(auxContract);
        this.$router.push({ name: "contractCreateStep3" });
      } else {
        this.$message({
          message:
            "Atención, Para continuar debes seleccionar un flujo de aprobación.",
          type: "warning"
        });
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.separator {
  margin: 40px 0;
}
.worflow-preview {
  border-left: solid 1px;
  padding-left: 20px;
}

.titleProfilesArea {
  color: #606266;
  font-size: 14px;
}
.textProfilesArea {
  margin-top: 10px;
  color: gray;
  font-size: 14px;
}
.centrar {
  text-align: center;
}
</style>
